import { request } from '../http';

const authenticationService = {
  login: (User, Password) => {
    return request.post('/login', { User, Password });
  }
};

export {
  authenticationService
};
